import { render, staticRenderFns } from "./desktop_form.vue?vue&type=template&id=f7c1ab8c"
import script from "./desktop_form.vue?vue&type=script&lang=ts"
export * from "./desktop_form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports